import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { SketchPicker } from 'react-color';

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
  label: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  color,
  onChange,
  label,
}) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleChange = (color: any) => {
    onChange(color.hex);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle1">{label}</Typography>
      <Box
        sx={{
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        }}
        onClick={() => setDisplayColorPicker(!displayColorPicker)}
      >
        <Box
          sx={{
            width: '36px',
            height: '14px',
            borderRadius: '2px',
            background: color,
          }}
        />
      </Box>
      {displayColorPicker && (
        <Box
          sx={{
            position: 'absolute',
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              position: 'fixed',
              top: '0px',
              right: '0px',
              bottom: '0px',
              left: '0px',
            }}
            onClick={() => setDisplayColorPicker(false)}
          />
          <SketchPicker color={color} onChange={handleChange} />
        </Box>
      )}
    </Box>
  );
};

export default ColorPicker;
